import { z } from "zod";
import { UserSchema } from "./User";

export const TaskTypeSchema = z.object({
  id: z.number(),
  typeName: z.string(),
  taskPriority: z.number(),
  isEvent: z.boolean(),
  defaultPlannedDate: z.number(),
  isAutomatic: z.boolean(),
  icon: z.string(),
  iconColor: z.string(),
  isTimeExtended: z.boolean(),
  notifyUser: z.boolean(),
  isPrivate: z.boolean(),
  isHidden: z.boolean(),
  defaultEventDate: z.number(),
});

export const TaskFieldsSchema = z.object({
  id: z.number(),
  taskName: z.string(),
  taskDescription: z.string(),
  beginDate: z.string(),
  endDate: z.string(),
  modificationDate: z.string(),
  createdAt: z.string(),
  completionDate: z.string(),
  isCompleted: z.boolean(),
  calendarData: z.string(),
  uri: z.string(),
  etag: z.string(),
  reminderBefore: z.any(),
  reminderRead: z.boolean(),
  remindDate: z.string(),
  importTyp: z.string(),
  importId: z.string(),
  importCode: z.string(),
  size: z.number(),
  componentType: z.string(),
  recurrenceActive: z.boolean(),
  recurrenceUntil: z.string(),
  recurrencePattern: z.number(),
  recurrenceInterval: z.number(),
  recurrenceUuid: z.string(),
  recurrenceExDates: z.array(z.string()),
  recurrenceParentBeginDate: z.nullable(z.string()),
  firstTask: z.nullable(z.any()),
  event: z.nullable(z.any()),
  user: UserSchema,
  creatorUser: UserSchema,
  type: TaskTypeSchema,
});

/**
 * Task zwracany w polu `relations.tasks`
 * do wybranych standardowych obiektów w systemie
 * */
export const ObjectRelationTaskSchema = z.object({
  id: z.number(),
  typeId: z.number(),
  type: z.string(),
  subtype: z.string(),
  name: z.string(),
  description: z.string(),
  typeName: z.string(),
  icon: z.string(),
  iconColor: z.string(),
  performer: z.any(),
  beginDate: z.string(),
  endDate: z.string(),
  calendarData: z.string(),
  recurrenceActive: z.boolean(),
  recurrence: z.object({
    uuid: z.string(),
    startDate: z.string(),
    endDate: z.string(),
    patternType: z.number(),
    intervalType: z.number(),
    excludedDates: z.array(z.string()),
  }),
});

export const PartialTaskFieldsSchema = TaskFieldsSchema.deepPartial();

export const TaskExtraFieldsSchema = z.object({
  nextTypes: z.array(z.object({})),
  availableTemplates: z.array(z.object({})),
});
export const PartialTaskExtraFieldsSchema = TaskExtraFieldsSchema.deepPartial();

export type TaskFields = z.infer<typeof TaskFieldsSchema>;
export type PartialTaskFields = z.infer<typeof PartialTaskFieldsSchema>;
export type TaskExtraFields = z.infer<typeof TaskExtraFieldsSchema>;
export type PartialTaskExtraFields = z.infer<
  typeof PartialTaskExtraFieldsSchema
>;

export type ObjectRelationTask = z.infer<typeof ObjectRelationTaskSchema>;
